import { useState } from 'react';
import './AdminAccess.css';

import { API } from '../../utils/API';

export default function AdminAccess() {
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(inputData);
    API.post('/login', inputData)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const [inputData, setInputData] = useState({
    userName: '',
    password: '',
  });

  return (
    <div className="AdminAccess">
      <form className="formContainer">
        <h2>LogIn</h2>
        <div className="formInputContainer">
          <input
            name="userName"
            id="userName"
            type="text"
            placeholder="UserName"
            onChange={(e) => handleChange(e)}
          />
          <label htmlFor="userName">UserName</label>
        </div>

        <div className="formInputContainer">
          <input
            name="password"
            type="password"
            id="password"
            placeholder="Password"
            onChange={(e) => handleChange(e)}
          />
          <label htmlFor="password">Password</label>
        </div>

        <button onClick={(e) => handleSubmit(e)}>Login</button>
      </form>
    </div>
  );
}
